export const orderTypeIds = {
    undefined: 0,
    // Платный заказ
    payed: 1,
    // Госзаказ
    government: 2,
    // Заявка от клиента
    clientRequest: 3,
    // Протокол/журнал без направления (часто из акта)
    nonReferral: 4,
};

const orderTypeLabels = {
    [orderTypeIds.payed]: 'Платный',
    [orderTypeIds.government]: 'Госзаказ',
    [orderTypeIds.clientRequest]: 'Заявка от клиента',
    [orderTypeIds.nonReferral]: 'Без направления',
};

export function getOrderTypeLabel(orderType) {
    const value = Number(orderType);
    return orderTypeLabels[value] ?? (value > 0 ? String(value) : '—');
}

/** Все не-госзаказные протоколы/журналы (платные, клиентские, без направления). */
export const paidOrderTypeExtraFilter = {
    orderType: {
        operand1: orderTypeIds.government,
        operator: 'notEquals',
    },
};

export const governmentOrderTypeExtraFilter = {
    orderType: {
        operand1: orderTypeIds.government,
        operator: 'equals',
    },
};